export const TOKEN_KEY = "USER_TOKEN"; // 用户token，由后台生成
export const PAY_CHANNEL_VERSION = "2";
export function baseUrl() {
  let payChannelVersion = "2";
  let baseUrl = "";
  // 根据页面路径名称，修改对应的api接口路径地址
  let host = window.location.host; // 获取URL的主机部分
  if (host == "sdb.giga99.com") {
    // if(payChannelVersion === "1"){
    //   setPayChannel("1007");
    // }else if(payChannelVersion === "2"){
    //   setPayChannel("1017");
    // }
    // baseUrl = "https://apisdb.giga99.com:8222";

    if(payChannelVersion === "1"){
      setPayChannel("1016");
    }else if(payChannelVersion === "2"){
      setPayChannel("1016");
    }
    baseUrl = "http://apifuqi.giga99.com";
  }
  else if (host == "sdb.ganzhoubx.com") {
    if(payChannelVersion === "1"){
      setPayChannel("1008");
    }else if(payChannelVersion === "2"){
      setPayChannel("1012");
    }
    baseUrl = "https://api.ganzhoubx.com:8222";
  }
  else if (host == "sdb.gzjiajiuhui.com") {
    if(payChannelVersion === "1"){
      setPayChannel("1005");
    }else if(payChannelVersion === "2"){
      setPayChannel("1018");
    }
    baseUrl = "https://api.gzjiajiuhui.com:8222";
  }
  else if (host == "sdb.fuqiyymx.com") {
    if(payChannelVersion === "1"){
      setPayChannel("1009");
    }else if(payChannelVersion === "2"){
      setPayChannel("1016");
    }
    baseUrl = "https://api.fuqiyymx.com:8222";
  }
  else if (host == "sdb.beifuyymx.com") {
    if(payChannelVersion === "1"){
      setPayChannel("1010");
    }else if(payChannelVersion === "2"){
      setPayChannel("1013");
    }
    baseUrl = "https://api.beifuyymx.com:8222";
  }
  else if (host == "sdb.cehaoyymx.com") {
    if(payChannelVersion === "1"){
      setPayChannel("1011");
    }else if(payChannelVersion === "2"){
      setPayChannel("1015");
    }
    baseUrl = "https://api.cehaoyymx.com:8222";
  }
  else if (host == "sdb.ganzhoublq.com") {
    if(payChannelVersion === "1"){
      setPayChannel("1004");
    }else if(payChannelVersion === "2"){
      setPayChannel("1014");
    }
    baseUrl = "https://api.ganzhoublq.com:8222";
  }
  else {
    setPayChannel("1012");
    // 测试地址
    baseUrl = "http://yts.natappvip.cc/sdb-api/";
  }
  setPayChannel("1019");
  baseUrl = "https://apisdb.giga99.com:8222";
  return baseUrl;
}



export function setToken(token) {
  return sessionStorage.setItem(TOKEN_KEY, token);
}

export function getToken() {
  return sessionStorage.getItem(TOKEN_KEY);
}

export function removeToken() {
  return sessionStorage.removeItem(TOKEN_KEY);
}

export function setUserInfo(data) {
  return sessionStorage.setItem("YYMX_USER", JSON.stringify(data));
}

export function getUserInfo() {
  let userInfo = sessionStorage.getItem("YYMX_USER");
  if (userInfo) {
    userInfo = JSON.parse(userInfo);
  }
  return userInfo;
}

export function removeUserInfo() {
  return sessionStorage.removeItem("YYMX_USER");
}

export function setPayChannel(data) {
  return sessionStorage.setItem("PAY_CHANNEL", data);
}

export function getPayChannel() {
  return sessionStorage.getItem("PAY_CHANNEL");
}

export const VERSION = "2.5.5"; // 当前系统版本

export const PRODUCTID = "8154648227158500"; // 产品固定id



// WEBPACK FOOTER //
// ./src/utils/auth.js